// extracted by mini-css-extract-plugin
export default {"wrapper":"CommunicationLog_wrapper__w2aFk","action-button":"CommunicationLog_action-button__NjNiz"};